import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { FeaturesDataDispatcher } from './features-data.dispatcher';
import { FeaturesDataEffects } from './features-data.effects';
import { FEATURE_NAME, reducer } from './features-data.reducer';
import { FeaturesDataResolve } from './features-data.resolve';
import { FeaturesDataService } from './features-data.service';
import { FeaturesDataStore } from './features-data.store';

export const featuresDataEffects = [FeaturesDataEffects];

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(FEATURE_NAME, reducer)],
})
export class FeaturesDataModule {
  static forRoot(): ModuleWithProviders<FeaturesDataModule> {
    return {
      ngModule: FeaturesDataModule,
      providers: [
        FeaturesDataStore,
        FeaturesDataDispatcher,
        FeaturesDataService,
        FeaturesDataResolve,
      ],
    };
  }
}
